import { HttpParams } from "@angular/common/http";

export class HttpUtils {

  /**
   * convert each property and its value of an object into a HttpParams key and value respectively
   * @param object
   * todo: i might be able to remove this one
   */
  public static convertObjectToParam(object: any) {

    let params = new HttpParams()

    //set object params
    if (object) {
      Object.keys(object).forEach(key => {
        const filterValue = object[key]
        if (filterValue !== null && filterValue !== '') params = params.append(key, object[key]);
      });
    }
    return params;
  }
}
